// extracted by mini-css-extract-plugin
export default {"root":"ListingRating_root__Pt84y","star":"ListingRating_star__HeO-8","average":"ListingRating_average__eDJEY","count":"ListingRating_count__oHv2J"};